module.exports = __webpack_public_path__ + "img/file-img-pptx.b6a538dd.jpg";